<template>
  <div id="addrmanage">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "addrmanage"
};
</script>

<style scoped>
</style>